// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination[data-v-fc948542]{margin-bottom:-1rem}.pagination .btn[data-v-fc948542]{min-width:2.25rem;padding:.5rem;margin-bottom:1rem}.pagination .btn[data-v-fc948542]:not(:last-child){margin-right:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
